import http from "../../helpers/http";
import * as helpers from "../../helpers/api";
import { toast } from "react-toastify";
import { TOAST_SETTINGS } from "../../utils/siteSettings";
import Text from "../../components/common/Text";

import {
  FETCH_BRANCH_CONTENT,
  FETCH_BRANCH_CONTENT_SUCCESS,
  FETCH_BRANCH_CONTENT_FAILED,
  BRANCH_MESSAGE,
  BRANCH_MESSAGE_SUCCESS,
  BRANCH_MESSAGE_FAILED,
} from "./actionTypes";

export const fetchBranch = (branch_id) => (dispatch) => {
  dispatch({
    type: FETCH_BRANCH_CONTENT,
    payload: null,
  });
  http
    .get("branch/" + branch_id)
    .then(({ data }) => {
      dispatch({
        type: FETCH_BRANCH_CONTENT_SUCCESS,
        payload: data,
      });
    })
    .catch((error) => {
      dispatch({
        type: FETCH_BRANCH_CONTENT_FAILED,
        payload: error,
      });
    });
};
export const postBranch = (formData, branch_id) => (dispatch) => {
  let postUrl = "";
  if (branch_id != undefined && branch_id !== null) {
    postUrl = "edit-branch/" + branch_id;
  } else {
    postUrl = "add-branch";
  }

  dispatch({
    type: BRANCH_MESSAGE,
    payload: null,
  });
  http
    .post(postUrl, helpers.doObjToFormData(formData))
    .then(({ data }) => {
      if (data.status) {
        toast.success(`${data.msg}`, TOAST_SETTINGS);
        setTimeout(() => {
          window.location.replace("/branches");
        }, 2000);
        dispatch({
          type: BRANCH_MESSAGE_SUCCESS,
          payload: data,
        });
      } else {
        toast.error(<Text string={data.msg} parse={true} />, TOAST_SETTINGS);
        dispatch({
          type: BRANCH_MESSAGE_FAILED,
          payload: null,
        });
      }
    })
    .catch((error) => {
      dispatch({
        type: BRANCH_MESSAGE_FAILED,
        payload: error,
      });
    });
};
